import {Button} from "../../../../design";
import VisaIcon from "../../../../assets/imgs/visa.png";
import MasterIcon from "../../../../assets/imgs/master.png";
import AmexIcon from "../../../../assets/imgs/ae.png";
import DiscoverIcon from "../../../../assets/imgs/discover.png";
import RupayIcon from "../../../../assets/imgs/rupay.png";
import React from "react";
import Support from "../../../../components/support";

type Props = {
  download: Function,
  account: Object,
  history: {
    push: Function,
  },
  email: string,
  phone: string,
  status: string
}

const DownLoadInvoice = (props:Props) => {
  const {download, history, phone, email, status, account} = props;
  const {location: { pathname }} = history;
  return(
    <div className="mt-5 text-center h-100 position-relative">
 <div className="pt-5 text-center">
 { status &&  (<><Button onClick={download}
        hidden={status === "ACTIVE"}
          type="secondary" border="1px solid #40a9ff !important" borderRadius="50px" className="px-4 py-2 mb-4">{account && account.organisationType === "NON_PROFIT" ? "Download Receipt" : "Download Invoice"}</Button>
        <br/>
        <Button hidden={status === "PAID" || status === "CANCELLED"} onClick={() => props.history.push(`${pathname}/pay`)}
          type="primary" border="1px solid #40a9ff !important" borderRadius="50px" className="px-5 py-2">{account && account.organisationType === "NON_PROFIT" ? "DONATE NOW" : "PAY NOW"}</Button></>)}
        <div className="mt-4">
          <img src={VisaIcon} height="20px" className="pr-4" alt={''}/>
          <img src={MasterIcon} height="20px" className="pr-4" alt={''}/>
          <img src={AmexIcon} height="20px" className="pr-4" alt={''}/>
          <img src={DiscoverIcon} height="20px" className="pr-4" alt={''}/>
          <img src={RupayIcon} height="20px" alt={''}/>
        </div>
      </div>
      <div className="mt-5 text-left" style={{bottom: "5%", position: "absolute"}}>
        <Support email={email} phone={phone}/>
      </div>
    </div>
  )
};

export default DownLoadInvoice
